// De laatste regel onder de openingsvragen: "Meer inspiratie". Klapt open naar
// onder, op zijn plek, en toont de dertien vragen van de owner; een klik stelt
// de vraag, nog een klik op de regel klapt hem weer dicht. Bij openen schuift
// de regel bovenin beeld, zodat de vragen eronder staan en de regel zelf
// bereikbaar blijft (owner 14-10: "ik kan niet meer terug"). Alleen in de
// nieuwe weergave (ChatPopup-prop `nieuweWeergave`), zodat de chat zoals hij
// live staat niet verandert.

import { useEffect, useRef, useState } from "react";

import { useActieveSector } from "../lib/sectorkeuze";
import { trendlaagAan } from "../nieuw/trendlaag/schakelaar";
import { inspiratieVoor } from "./chatInspiratieVragen";
import { color, radius, size, weight } from "./chatTokens";

export function ChatInspiratie({ onVraag }: { onVraag: (q: string) => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  // Pilot gereed 26-10 (1C): ICT-vragen alleen als de schermen op ICT staan.
  // Trendlaag (schakelaar aan): dezelfde vragen in trendlaagwoorden.
  const vragen = inspiratieVoor(useActieveSector(), trendlaagAan());
  useEffect(() => {
    const el = ref.current;
    if (open && el && typeof el.scrollIntoView === "function") el.scrollIntoView({ block: "start", behavior: "smooth" });
  }, [open]);
  return (
    <div ref={ref} style={{ scrollMarginTop: 8, border: `1px solid ${color.line}`, borderRadius: radius.card, background: color.surface }}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 11,
          width: "100%",
          padding: "13px 16px",
          border: 0,
          borderRadius: radius.card,
          background: "transparent",
          cursor: "pointer",
          textAlign: "left",
          fontFamily: "inherit",
        }}
      >
        <span style={{ fontSize: size.body, color: color.disabled, display: "inline-block", transform: open ? "rotate(90deg)" : "none", transition: "transform 0.12s" }}>›</span>
        <span style={{ fontSize: 13.5, color: color.body, flex: 1, fontWeight: weight.medium }}>Meer inspiratie</span>
        <span style={{ fontSize: size.meta, color: color.faint }}>{vragen.length} vragen</span>
      </button>
      {open && (
        <div style={{ padding: "0 8px 10px", display: "flex", flexDirection: "column" }}>
          {vragen.map((q) => (
            <button
              key={q}
              type="button"
              onClick={() => onVraag(q)}
              style={{
                display: "flex",
                gap: 10,
                padding: "8px 10px",
                border: 0,
                borderRadius: radius.input,
                background: "transparent",
                cursor: "pointer",
                textAlign: "left",
                fontFamily: "inherit",
                fontSize: 13.5,
                color: color.body,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = color.surfaceHover)}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <span style={{ color: color.disabled }}>›</span>
              <span style={{ flex: 1 }}>{q}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
